import { render, staticRenderFns } from "./ContactsToolbar.vue?vue&type=template&id=2f04b83f&"
import script from "./ContactsToolbar.vue?vue&type=script&lang=js&"
export * from "./ContactsToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports